<template>
  <div class="out-wrapper">
    <div class="nav-wrapper">
      <div class="logo-wrapper" @click="goto('/product')">
        <img src="@/assets/logo/logo.png" alt="" />
      </div>
      
      <!-- 手机端汉堡菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleMobileMenu">
        <div class="hamburger" :class="{ 'active': mobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      <div class="menu-wrapper">
                <div class="menu-nav">
                    <div class="menu-item" :class="$route.path.startsWith(menu.url) ? 'active' : ''" v-for="(menu, index) in topMenus" :key="index">
                        <router-link :to="menu.url">
                            <i class="iconfont" v-if="menu.icon">{{ menu.icon }}</i>
                            <span>{{ menu.title }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
      <div class="nav-right-box">
        <div class="search-box"></div>
        <div class="btn-wrapper">
          <div class="language-wrapper">
            <div class="language">
              <i class="iconfont icon-btn" v-show="language == 'zh'"
                >&#xe6444;</i
              >
              <i class="iconfont icon-btn" v-show="language == 'en'"
                >&#xe6445;</i
              >
            </div>
            <div class="international-panel">
              <div
                class="panel-item"
                @click="handleChaneLanguage('zh')"
                :class="language == 'zh' ? 'disabled' : ''"
              >
                <span>简体中文</span>
              </div>
              <div
                class="panel-item"
                @click="handleChaneLanguage('en')"
                :class="language == 'en' ? 'disabled' : ''"
              >
                <span>English</span>
              </div>
            </div>
          </div>
          <!-- <div class="right-btn" v-if="!userInfo" @click="SHOW_OR_HIDE">
            <div>
              <i class="iconfont">&#xe61f;</i>
              <span> {{$t("navMenus.btn.connect")}} </span>
            </div>
          </div> -->
          <div class="right-btn" v-if="!userInfo" @click="twitterLogin()">
            <div>
              <!-- <i class="iconfont">&#xe61f;</i> -->
              <span> {{ $t("navMenus.btn.twitter") }} </span>
            </div>
          </div>
          <div class="right-btn" v-if="!userInfo" @click="googleLogin()">
            <div>
              <span> {{ $t("navMenus.btn.google") }} </span>
            </div>
          </div>
          <div class="login-wrapper" v-if="userInfo">
            <div class="login-btn">
              <div class="wallet-wrapper">
                <i class="iconfont">&#xe61f;</i>
              </div>
              <div class="wallet-address">
                <span>{{ userInfo.nickName }}</span>
                <i
                  class="iconfont arrow"
                  :class="walletInfoShow ? 'rotation' : ''"
                  >&#xe87e;</i
                >
              </div>
              <div
                class="login-panel"
                :class="walletInfoShow ? 'login-active' : ''"
              >
                <!-- <div class="panel-item" @click="copy()">
                                  <i class="iconfont">&#xeb4e;</i>
                                <span>{{ $t("navMenus.other.copy") }}</span>
                            </div> -->
                <div class="panel-item" @click="goto('/userCenter')">
                  <i class="iconfont">&#xeb4e;</i>
                  <span>{{ $t("navMenus.other.usercenter") }}</span>
                </div>
                <div class="panel-item" @click="logout()">
                  <i class="iconfont">&#xe651;</i>
                  <span>{{ $t("navMenus.other.logout") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 手机端侧边栏菜单 -->
    <div class="mobile-menu-overlay" v-if="mobileMenuOpen" @click="toggleMobileMenu"></div>
    <div class="mobile-menu-sidebar" :class="{ 'open': mobileMenuOpen }">
      <div class="mobile-menu-header">
        <div class="mobile-menu-title">Utools</div>
        <div class="mobile-menu-close" @click="toggleMobileMenu">
          <i class="iconfont">&#xe64b;</i>
        </div>
      </div>
      <div class="mobile-menu-content">
        <div class="mobile-welcome" v-if="userInfo">
          Welcome, {{ userInfo.nickName }}
        </div>
        <div class="mobile-menu-item" 
             :class="$route.path.startsWith(menu.url) ? 'active' : ''" 
             v-for="(menu, index) in topMenus" 
             :key="index"
             @click="handleMobileMenuClick(menu.url)">
          <router-link :to="menu.url">
            <i class="iconfont" v-if="menu.icon">{{ menu.icon }}</i>
            <span>{{ menu.title }}</span>
          </router-link>
        </div>
        <div class="mobile-login-section" v-if="!userInfo">
          <div class="mobile-login-btn" @click="twitterLogin()">
            <span>{{ $t("navMenus.btn.twitter") }}</span>
          </div>
          <div class="mobile-login-btn" @click="googleLogin()">
            <span>{{ $t("navMenus.btn.google") }}</span>
          </div>
        </div>
        <div class="mobile-user-section" v-if="userInfo">
          <div class="mobile-menu-item" @click="goto('/userCenter')">
            <i class="iconfont">&#xeb4e;</i>
            <span>{{ $t("navMenus.other.usercenter") }}</span>
          </div>
          <div class="mobile-menu-item" @click="logout()">
            <i class="iconfont">&#xe651;</i>
            <span>{{ $t("navMenus.other.logout") }}</span>
          </div>
        </div>
        <div class="mobile-language-section">
          <div class="mobile-menu-item" @click="handleChaneLanguage('zh')" :class="language == 'zh' ? 'disabled' : ''">
            <span>简体中文</span>
          </div>
          <div class="mobile-menu-item" @click="handleChaneLanguage('en')" :class="language == 'en' ? 'disabled' : ''">
            <span>English</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import networks from "@/assets/json/networks.json";
import { thirdLogin } from "@/api/user";
import { getCookie, setCookie } from "@/utils/cookie";
export default {
  name: "HeaderNav",
  data() {
    return {
      mobileMenu: "#icon-caidan1",
      mobileMenuIsShow: false,
      mobileMenuOpen: false,
      isShowBatchMenu: false,
      isShowCommonMenu: false,
      isShowWallet: false,
      clientHeight: 0, //视口高度
      display: false,
      drawerWidth: "100%",
      mobileMenus: [],
      topMenus: [
        {
            title: this.$t("navMenus.menus.home"),
            icon: null,
            url: "/web3Tools",
        },
        {
          title: this.$t("navMenus.menus.product"),
          icon: null,
          url: "/product",
        },
        {
          title: this.$t("navMenus.menus.pay"),
          icon: null,
          url: "/pay",
        },      
         {
          title: this.$t("navMenus.menus.listener"),
          icon: null,
          url: "/listener",
        },     
        {
          title: this.$t("navMenus.menus.tools"),
          icon: null,
          url: "/tools",
        },
                {
          title: this.$t("navMenus.menus.download"),
          icon: null,
          url: "/videoDownload",
        },   
        // {
        //   title: this.$t("navMenus.menus.account"),
        //   icon: null,
        //   url: "/twitterAccount",
        // }, 
      
        // {
        //     title: this.$t("navMenus.menus.dematch"),
        //     icon: null,
        //     url: "/deMatchTools",
        // },
      ],
      menuIsShow: false,
      walletInfoShow: false,
      visible: false,
      blockNetworks: null,
      chainId: null,
      currentNetName: null,
      language: getCookie("language") || "zh", 
    };
  },
  methods: {
    // ...mapActions("wallet", ["initData"]),
    ...mapMutations("wallet", [
      "SHOW_OR_HIDE",
      "LOGOUTED",
      "UPDATE_WEB3_INFO",
      "INIT_LOGIN_INFO",
    ]),
    async twitterLogin() {
      let { data } = await thirdLogin({ type: "twitter" });
      console.log("googleLogin:", data.data);
      if (data.code == 1) {
        // this.$toast.success("推特登录成功");
        window.location.href = data.data;
      } else {
        this.$toast.error(this.$t("usercenter.tip.get_twitter_url_failed"));
      }
    },

    async googleLogin() {
      let { data } = await thirdLogin({ type: "google" });
      console.log("googleLogin:", data.data);
      if (data.code == 1) {
        // 打印google授权地址，方便调试
        console.log("Google授权地址:", data.data);
        // this.$toast.success("谷歌登录成功");
        window.location.href = data.data;
      } else {
        this.$toast.error(this.$t("usercenter.tip.get_google_url_failed"));
      }
    },
    connectWallet() {
      this.isShowWallet = false;
      this.SHOW_OR_HIDE();
    },
    menuSwitch() {
      this.mobileMenuIsShow = !this.mobileMenuIsShow;
      // console.log(this.mobileMenuIsShow);
      this.$refs.transition.performTransition();
    },
    goto(url) {
      if (this.mobileMenuIsShow) this.menuSwitch();
      this.isShowBatchMenu = false;
      this.isShowCommonMenu = false;

      if (this.$route.path == url) {
        return;
      }
      this.$router.push({
        path: url,
      });
    },
    handleChaneLanguage(locale) {
      let language = getCookie("language");
      if (locale !== language) {
        this.$i18n.locale = locale;
        setCookie("language", locale);
        window.location.reload();
      }
    },
    copy() {
      this.$copyText(this.netInfo.address)
        .then(() => {
          // alert(this.$t("navMenus.other.copySuccess"))
          this.$toast.success(this.$t("navMenus.other.copySuccess"));
        })
        .catch(() => {
          this.$toast.error(this.$t("navMenus.other.copyError"));
        });
    },
    logout() {
      this.LOGOUTED();
    },
    showOrHideMenu() {
      // console.log("show hide");
      this.menuIsShow = !this.menuIsShow;
    },
    showOrHideWalletInfo() {
      this.walletInfoShow = !this.walletInfoShow;
    },
    showModal() {
      this.visible = true;
    },
    closeModal() {
      this.visible = false;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.updateHamburgerStyle();
    },
    updateHamburgerStyle() {
      const hamburger = document.querySelector('.hamburger');
      if (hamburger) {
        if (this.mobileMenuOpen) {
          hamburger.classList.add('active');
        } else {
          hamburger.classList.remove('active');
        }
      }
    },
    handleMobileMenuClick(url) {
      this.goto(url);
      this.mobileMenuOpen = false;
      this.updateHamburgerStyle();
    },
    metaMaskListener() {
      ethereum.on("accountsChanged", (accounts) => {
        // console.log("new account---",accounts[0])
        if (accounts.length === 0) {
          // MetaMask is locked or the user has not connected any accounts
          console.log("Please connect to MetaMask.");
        } else if (accounts[0] !== this.netInfo.address) {
          this.UPDATE_WEB3_INFO({
            address: accounts[0],
            chainId: this.chainId,
          });
          window.location.reload();
        }
      });
      ethereum.on("chainChanged", (chainId) => {
        console.log("new chainId---", web3.utils.hexToNumber(chainId));
        this.UPDATE_WEB3_INFO({
          address: this.netInfo.address,
          chainId: web3.utils.hexToNumber(chainId),
        });
        window.location.reload();
      });
    },
    async switchNet(item) {
      // console.log(item)
      try {
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: web3.utils.numberToHex(item.chainId) }],
        });
      } catch (switchError) {
        console.log("switch network error:", switchError);
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: web3.utils.numberToHex(item.chainId),
                  chainName: item.name,
                  rpcUrls: [item.rpcUrl] /* ... */,
                  nativeCurrency: {
                    name: item.token,
                    symbol: item.token, // 2-6 characters long
                    decimals: 18,
                  },
                  blockExplorerUrls: [item.BlockBrowser],
                },
              ],
            });
          } catch (addError) {
            console.log("add network error:", addError);
            // handle "add" error
          }
        }
        // handle other "switch" errors
      }
    },
    closeWallet() {
      this.isShowWallet = false;
    },
  },

  computed: {
    ...mapState("wallet", [ "netInfo", "userInfo"]),
  },
  watch: {
    isShowWallet(newValue, oldValue) {
      console.log(newValue, oldValue);
      this.$refs.right_transition.performTransition();
      if (this.isShowWallet) {
        document.body.addEventListener("click", this.closeWallet, false);
      } else {
        document.body.removeEventListener("click", this.closeWallet);
      }
    },
  },
  mounted() {
    let lang = getCookie("language");
    this.language = (lang === 'en') ? 'en' : 'zh';  // 只接受 zh 或 en，其他强制 zh
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    this.clientHeight = h;
    // this.initData(); //初始化小狐狸钱包组件
    // this.INIT_LOGIN_INFO();  //初始化用户信息到store
    this.blockNetworks = networks;
    let currentNetwork = null;
    // this.chainId = localStorage.getItem("chainId");
    // setTimeout(() => {
    //   this.chainId = this.netInfo.chainId;
    //   console.log(this.chainId);
    //   if (this.chainId) {
    //     for (let i = 0; i < this.blockNetworks.length; i++) {
    //       let item = this.blockNetworks[i];
    //       let nets = item.networks;
    //       for (let j = 0; j < nets.length; j++) {
    //         let net = nets[j];
    //         if (net.chainId == this.chainId) {
    //           this.currentNetName = net.name;
    //           // console.log(this.currentNetName)
    //           currentNetwork = net;
    //           break;
    //         }
    //       }
    //     }
    //     localStorage.setItem("currentNetwork", JSON.stringify(currentNetwork));
    //   }
    // }, 1000);
    // let lang = getCookie("language");
    // this.language = lang;
    // if (web3) {
    //   this.metaMaskListener();
    // }
    //this.userInfo = getCookie("userInfo") ? JSON.parse(getCookie("userInfo")) : null
    // this.clientHeight = window.screen.availHeight;
    // this.$toast.success(this.clientHeight)
    // console.log("window height : ", this.clientHeight);
    // console.log(window.screen.availHeight)
    // window.alert(window.screen.availHeight)
    // let h = document.documentElement.clientHeight || document.body.clientHeight;
    // this.clientHeight = h;
    // console.log(h);

    // console.log("window.innerHeight : ", window.innerHeight);
    // this.clientHeight = h;
    // this.$toast.error(`${h}`);
  },
};
</script>

<style lang="scss" scoped>
* {
  color: #fff;
}

.out-wrapper {
  width: 100%;
  height: 80px;
  background: #0c122d; // max-width: 1300px;
  // min-width: 1200px;
  // background-color: #fff;
  // box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  min-width: 375px;
  position: fixed;
  top: 0px;
  z-index: 997;
  display: flex; // align-content: center;
  justify-content: center;
  flex-wrap: wrap; // border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  // position: relative;
  .logo-wrapper {
    cursor: pointer;
    margin-left: 40px;
    display: flex;
    align-items: center;
    img {
      // width: 180px;
      height: 40px;
    }
  }
  
  // 手机端汉堡菜单按钮
  .mobile-menu-btn {
    display: none;
    position: fixed;
    right: 20px;
    top: 20px;
    width: 44px;
    height: 44px;
    background: rgba(30, 41, 59, 0.8);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    z-index: 9999;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    
    .hamburger {
      width: 20px;
      height: 14px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 14px auto; /* Center vertically and horizontally */
      
      span {
        display: block;
        width: 100%;
        height: 2px;
        background: #ffffff;
        border-radius: 2px;
        transition: all 0.3s ease;
        transform-origin: left center;
      }
      
      &.active {
        span:nth-child(1) {
          transform: rotate(45deg);
           width: 20px;
        }
        
        span:nth-child(2) {
          opacity: 0;
          width: 0;
        }
        
        span:nth-child(3) {
          transform: rotate(-45deg);
           width: 20px;
        }
      }
    }
  }
  
  // 手机端侧边栏菜单
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
  }
  
  .mobile-menu-sidebar {
    position: fixed;
    top: 0;
    right: -100%;
    width: 280px;
    height: 100%;
    background: #0c122d;
    z-index: 1000;
    transition: right 0.3s ease;
    overflow-y: auto;
    
    &.open {
      right: 0;
    }
    
    .mobile-menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      
      .mobile-menu-title {
        font-size: 20px;
        font-weight: bold;
        color: $global-color;
      }
      
      .mobile-menu-close {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;
        
        i {
          color: #ffffff;
          font-size: 18px;
        }
        
        &:hover {
          background: rgba(255, 255, 255, 0.15);
          transform: rotate(90deg);
        }
      }
    }
    
    .mobile-menu-content {
      padding: 20px;
      
      .mobile-welcome {
        margin-bottom: 20px;
        font-size: 16px;
        color: #fff;
      }
      
      .mobile-menu-item {
        margin-bottom: 15px;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
        
        &:hover {
          background: rgba(59, 130, 246, 0.1);
        }
        
        &.active {
          background: rgba(59, 130, 246, 0.15);
        }
        
        a {
          display: flex;
          align-items: center;
          
          i {
            margin-right: 10px;
            font-size: 18px;
            color: #3b82f6;
          }
          
          span {
            font-size: 16px;
            color: #fff;
          }
        }
      }
      
      .mobile-login-section,
      .mobile-user-section,
      .mobile-language-section {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        
        .mobile-login-btn {
          margin-bottom: 15px;
          padding: 10px;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
          
          &:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          }
          
          span {
            font-size: 16px;
            color: #fff;
          }
        }
      }
    }
  }
  
  .nav-wrapper {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center; // 新增垂直居中
    padding: 0 20px;
    box-sizing: border-box;
    .logo-wrapper {
      flex: 0 0 auto; // 不拉伸/收缩，保持宽度
      margin-left: 0;
      display: flex;
      align-items: center;
      img { height: 40px; }
    }

    .menu-wrapper {
      /* 允许菜单区域根据可用空间收缩 / 扩展 */
      flex: 1 1 auto;
      min-width: 0; /* 关键：允许内部横向滚动时收缩 */
      display: flex;
      align-items: center;

      .menu-nav {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: clamp(12px, 3vw, 50px);
        padding: 0 10px;
        /* 始终允许横向滚动，避免推走右侧按钮 */
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        white-space: nowrap; /* 保持单行 */
        min-width: 0;

        /* 美化滚动条（可选） */
        &::-webkit-scrollbar { height: 6px; }
        &::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 3px; }

        .menu-item {
          line-height: 80px;
          position: relative;
          flex: 0 0 auto;
          transition: all 0.3s ease;
          
          a {
            display: flex;
            align-items: center;
            padding: 0 16px;
            height: 80px;
            position: relative;
            
            i { 
              font-size: 20px; 
              margin-right: 6px; 
              transition: all 0.3s ease;
            }
            span {
              font-size: 16px;
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
              font-weight: 500;
              color: rgba(255,255,255,0.7);
              transition: all 0.3s ease;
            }
            
            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              width: 0;
              height: 2px;
              background: linear-gradient(90deg, #3b82f6, #8b5cf6);
              transform: translateX(-50%);
              transition: width 0.3s ease;
            }
            
            &:hover { 
              cursor: pointer; 
              
              span { 
                color: #fff; 
              }
              
              &::after {
                width: 80%;
              }
            }
          }
          
          &.active {
            a {
              i {
                color: #3b82f6;
                transform: scale(1.1);
              }
              span {
                color: #3b82f6;
                font-weight: 600;
              }
              
              &::after {
                width: 80%;
              }
            }
          }
        }
      }
    }

    .nav-right-box {
      // position: absolute;
      // right: 20px;
      // top: 0px;
      // width: 460px;
      // height: 80px;
      // line-height: 80px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .btn-wrapper {
        // width: 140px;
        display: flex;
        justify-content: space-evenly;
        align-items: center; // .language-wrapper .right-btn,
        .right-btn {
          // padding: 0px 16px;
          // background-color: $global-color;
          // border-radius: 20px;
          // font-size: 14px;
          // line-height: 40px;
          // min-width: 80px;
          cursor: pointer;
          width: 140px;
          height: 40px;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          border-radius: 20px;
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
            transition: left 0.5s ease;
          }
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
            
            &::before {
              left: 100%;
            }
          }
          
          &:active {
            transform: translateY(0);
          }
          
          div {
            i {
              font-size: 24px;
              opacity: 1;
            }
            span {
              font-size: 16px;
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
              font-weight: 500;
              color: #ffffff;
              line-height: 20px;
            }
          }
        }
        .language-wrapper {
          position: relative;
          height: 80px;
          display: flex;
          align-items: center;
          .language {
            margin-right: 10px;
            cursor: pointer;
            width: 36px;
            height: 36px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(59, 130, 246, 0.1);
            border: 1px solid rgba(59, 130, 246, 0.2);
            transition: all 0.3s ease;
            
            i {
              font-size: 20px;
              color: #3b82f6;
              transition: all 0.3s ease;
            }
            
            &:hover {
              background: rgba(59, 130, 246, 0.2);
              transform: scale(1.05);
            }
          }
          &:hover {
            .international-panel {
              display: block;
            }
          }
          .international-panel {
            display: none;
            width: 120px;
            background: rgba(30, 41, 59, 0.95);
            backdrop-filter: blur(20px);
            border-radius: 12px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05) inset;
            position: absolute;
            right: -25px;
            top: 60px;
            padding: 8px;
            border: 1px solid rgba(148, 163, 184, 0.1);
            
            &:hover {
              display: block;
            }
            .panel-item {
              margin-top: 4px;
              height: 40px;
              line-height: 40px;
              border-radius: 8px;
              display: flex;
              align-items: center;
              transition: all 0.2s ease;
              
              span {
                margin-left: 16px;
                width: 80px;
                font-size: 14px;
                font-weight: 400;
                color: #cbd5e1;
                line-height: 20px;
                transition: all 0.2s ease;
                
                i {
                  font-size: 16px;
                  margin-right: 10px;
                }
              }
              &:hover {
                background: rgba(59, 130, 246, 0.15);
                border-radius: 8px;
                cursor: pointer;
                
                span {
                  color: #ffffff;
                }
              }
              
              &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
                
                &:hover {
                  background: transparent;
                }
              }
            }
          }
        }
        .btn-item {
          // height: 80px;
          // line-height: 80px;
          margin-left: 10px;
          div {
            // display: inline-flex;
            // line-height: 80px;
            .icon-btn {
              font-size: 24px;
              color: #5d5e67;
            }
            &:hover {
              .icon-btn {
                color: $global-color;
              }
            }
          } //登录成功box
        }
        .network-div {
          display: flex;
          align-items: center;
          background-color: $global-bg-color;
          border: 1px solid $global-color;
          border-radius: 10px;
          height: 30px;
          padding: 0 10px;
          cursor: pointer;
          span {
            color: $global-color;
            font-size: 14px;
            margin-right: 5px;
            white-space: nowrap;
          }
          i {
            color: $global-color;
            font-size: 12px;
            transition: all 0.3s;
          }
        }
        .login-wrapper {
          margin-left: 10px;
          height: 80px;
          position: relative;
          cursor: pointer;
          
          .login-btn {
            display: flex;
            align-items: center;
            height: 80px;
            
            .wallet-wrapper {
              width: 32px;
              height: 32px;
              background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              top: 24px;
              left: 5px;
              z-index: 2;
              box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
              border: 2px solid rgba(255, 255, 255, 0.1);
              
              i {
                color: #ffffff;
                font-size: 16px;
              }
            }
            
            .wallet-address {
              background: rgba(30, 41, 59, 0.6);
              backdrop-filter: blur(10px);
              border: 1px solid rgba(148, 163, 184, 0.2);
              border-radius: 20px;
              padding: 6px 12px 6px 36px;
              font-size: 14px;
              font-weight: 500;
              color: #e2e8f0;
              margin-left: 20px;
              display: flex;
              align-items: center;
              transition: all 0.3s ease;
              height: 36px;
              box-sizing: border-box;
              
              i {
                margin-left: 6px;
                font-size: 12px;
                transition: all 0.3s;
                color: #94a3b8;
              }
              
              .rotation {
                transform: rotate(180deg);
              }
            }
            
            &:hover {
              .wallet-address {
                background: rgba(59, 130, 246, 0.1);
                border-color: rgba(59, 130, 246, 0.4);
                color: #ffffff;
                
                i {
                  color: #ffffff;
                }
                
                .arrow {
                  transform: rotate(180deg);
                }
              }
              
              .login-panel {
                display: block;
                animation: fadeIn 0.2s ease-out;
              }
            }
            
            .login-panel {
              display: none;
              width: 160px;
              background: rgba(15, 23, 42, 0.95);
              backdrop-filter: blur(20px);
              border-radius: 12px;
              border: 1px solid rgba(148, 163, 184, 0.1);
              box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
              position: absolute;
              right: 0;
              top: 70px;
              padding: 6px;
              z-index: 100;
              
              @keyframes fadeIn {
                from { opacity: 0; transform: translateY(-10px); }
                to { opacity: 1; transform: translateY(0); }
              }
              
              .panel-item {
                margin-top: 2px;
                height: 40px;
                line-height: 40px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                padding-left: 12px;
                transition: all 0.2s ease;
                justify-content: flex-start;
                
                i {
                  font-size: 16px;
                  margin-right: 10px;
                  color: #94a3b8;
                  transition: all 0.2s ease;
                  padding-right: 0;
                }
                
                span {
                  font-size: 14px;
                  font-weight: 500;
                  color: #cbd5e1;
                  line-height: 20px;
                  transition: all 0.2s ease;
                  
                  i {
                    font-size: 16px;
                    margin-right: 10px;
                  }
                }
                
                &:hover {
                  background: rgba(59, 130, 246, 0.15);
                  border-radius: 8px;
                  opacity: 1;
                  cursor: pointer;
                  
                  i {
                    color: #60a5fa;
                  }
                  
                  span {
                    color: #ffffff;
                  }
                }
              }
            }
          }
          .login-active {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }
  
  // 响应式样式
  @media only screen and (max-width: 1000px) {
    .nav-wrapper {
      .menu-wrapper,
      .nav-right-box {
        display: none;
      }
    }
    
    .mobile-menu-btn {
      display: block;
    }
  }
  
  // 确保在所有屏幕尺寸下都不会出现横向滚动
  @media only screen and (max-width: 768px) {
    .out-wrapper {
      overflow-x: hidden;
    }
    
    .nav-wrapper {
      padding: 0 10px;
    }
  }
}
</style>